module.exports = __webpack_public_path__ + "img/listen-on-pocketcasts.4ce9f3cc.png";